import React from 'react';
import { Link } from 'gatsby';
import { Row, Col } from "react-flexgrid"
import styled from '@emotion/styled';
import { faLinkedin, faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons';

import Button from './Button';
import SocialButton from './SocialButton';

const StyledHeader = styled(Row)`
  @media (min-width: 745px) {
    margin-bottom: 60px;
  }
  @media (max-width: 745px) {
    margin-bottom: 20px;
  }
  margin-left: 0;
  margin-right: 0;
`;

const StyledAnchorHeader = styled(Link)`
  text-decoration: none;
`;

const StyledHeaderText = styled.h2`
  margin-bottom: 0;
  letter-spacing: 2px;
  font-weight: 100;
`;

const StyledSubtitleText = styled.h3`
  margin-bottom: 0;
  font-weight: 100;
  font-size: 20px;
`;

const HeaderSocialIcon = styled(SocialButton)`
  margin-right: 15px;
`;

const StyledButtonColumn = styled(Col)`
  @media (max-width: 745px) {
    margin-top: 20px;
  }
`;

const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Header = ({ title, subtitle, didClickContact }) => (
  <StyledHeader between="xs">
    <Col lg="6">
      <StyledAnchorHeader to="/">
        <StyledHeaderText>
          {title}
        </StyledHeaderText>
        <StyledSubtitleText>
          {subtitle}
        </StyledSubtitleText>
      </StyledAnchorHeader>
    </Col>
    <StyledButtonColumn lg="6">
      <StyledButtonContainer>
          <HeaderSocialIcon link="https://mobile.twitter.com/AlexCatchpole3" target="__blank" icon={faTwitter} />
          <HeaderSocialIcon link="https://www.linkedin.com/in/alex-catch" target="__blank" icon={faLinkedin} />
          <HeaderSocialIcon link="https://github.com/AlexCatch" target="__blank" icon={faGithub} />
          <Button onClick={didClickContact}>
            Contact Me
          </Button>
      </StyledButtonContainer>
    </StyledButtonColumn>
  </StyledHeader>
);

export default Header;
